import React from "react";
import { GridColDef } from "@mui/x-data-grid";
import { format, parseISO } from "date-fns";
import { ApprovalCell, ApprovalIcon } from "../../components";
import { Absence, ApprovalStatus } from "../../API";

type Actions = {
  showActionModal: (
    params?:
      | {
          row: Absence;
          status: ApprovalStatus;
        }
      | undefined
  ) => void;
};

export const columns = ({
  showActionModal,
}: Actions): GridColDef<Absence>[] => [
  {
    field: "approvalStatus",
    headerName: "Status",
    width: 72,
    align: "center",
    renderCell: ({ value }) => <ApprovalIcon status={value} />,
  },
  {
    field: "employee",
    headerName: "Employee",
    minWidth: 100,
    flex: 1,
    align: "left",
    valueGetter: ({ row: { employee } }) =>
      `${employee.firstName} ${employee.lastName}`,
  },
  {
    field: "approvedByClient",
    headerName: "Approved by Client",
    width: 100,
    align: "left",
    renderCell: ({ value }) => (
      <ApprovalIcon status={value ? "approved" : "pending"} />
    ),
  },
  {
    field: "startDate",
    headerName: "Start",
    align: "left",
    minWidth: 112,
    renderCell: ({ value }) => format(parseISO(value), "dd/MM/yyyy"),
  },
  {
    field: "endDate",
    headerName: "End",
    align: "left",
    minWidth: 112,
    renderCell: ({ value }) => format(parseISO(value), "dd/MM/yyyy"),
  },
  {
    field: "hoursTaken",
    headerName: "Hours",
    align: "left",
  },
  {
    field: "amount",
    headerName: "Amount",
    align: "left",
  },
  {
    field: "description",
    headerName: "Description",
    align: "left",
    minWidth: 200,
  },
  {
    field: "logIds",
    headerName: "Approval",
    type: "actions",
    minWidth: 200,
    renderCell: ({ row }) => (
      <ApprovalCell
        disable={{
          approve:
            row.approvalStatus === "approved" ||
            row.approvalStatus === "rejected",
          reject: row.approvalStatus === "rejected",
        }}
        onApprove={() =>
          showActionModal({ row, status: ApprovalStatus.approved })
        }
        onReject={() =>
          showActionModal({ row, status: ApprovalStatus.rejected })
        }
      />
    ),
  },
];

export const hiddenColumnsDesktop: { [key: string]: boolean } = {
  overtime: false,
};

export const hiddenColumnsMobile: { [key: string]: boolean } = {
  ...hiddenColumnsDesktop,
  sick: false,
  holiday: false,
};
